import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Fonts, Metrics, Colors } from '../../Themes'

const Card = styled.div`
  border: ${Metrics.borders.default};
  width: 100%;
  min-height: 315px;
  position: relative;
  overflow: hidden;
  background: ${Colors.white};
`

const ImageContainer = styled.div`
  width: 100%;
  height: 190px;
  overflow: hidden;
  background: url(${props => props.src}) no-repeat center;
  background-size: cover;
  position: relative;
`

const Content = styled.div`
  overflow-y: scroll;
  margin-top: ${Metrics.margins.base};
  ${Fonts.style.Text};
`

const Icon = styled.div`
  position: absolute;
  height: 50px;
  right: 10px;
  top: 5px;
  width: 80px;
  cursor: pointer;
  z-index: 1;
`

const Layer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  width: 100%;
`

const CardWithImage = props => {
  const { imgSrc, children, icon } = props

  return (
    <Card {...props}>
      <ImageContainer src={imgSrc}>
        {icon && <Icon>{icon}</Icon>}
        <Layer />
      </ImageContainer>
      <Content>{children}</Content>
    </Card>
  )
}

CardWithImage.propTypes = {
  children: PropTypes.node,
  imgSrc: PropTypes.string.isRequired,
  icon: PropTypes.node
}

export default CardWithImage



// WEBPACK FOOTER //
// ./src/components/CardWithImage/index.js